import Calendar from "@/assets/Icons/calendar";
import { formatDate } from "@/lib/utils";
import Image from "next/image";
import Link from "next/link";

type CardAnnounProps = {
  image: string; // url image (bisa dari public atau url external)
  date: string;
  unduh: string;
  title: string;
  description: string;
  href: string;
};

const CardAnnoun = ({
  image,
  date,
  unduh,
  title,
  description,
  href,
}: CardAnnounProps) => {
  return (
    <div className="flex flex-col gap-4 rounded-xl overflow-hidden bg-white shadow-md">
      <div className="h-[250px] w-full p-3">
        <Image
          alt="annon"
          src={image ?? "/assets/images/default-information.png"}
          width={500}
          height={500}
          className="h-full w-full object-cover rounded-md bg-primary-500"
        />
      </div>
      <div className="flex items-center justify-between px-3">
        <div className="flex gap-2 items-center">
          <Calendar />
          <div className="text-[#70707B] font-medium">{formatDate(date)}</div>
        </div>
      </div>
      <div className="flex flex-col gap-2 px-3 h-full justify-between pb-4">
        <div className="">
          <div className="font-semibold text-lg md:text-xl">{title}</div>
          <div
            className="line-clamp-3 text-[#70707B] text-justify text-sm md:text-base"
            dangerouslySetInnerHTML={{ __html: description ?? "" }}
          />
        </div>
        <div className="flex justify-center gap-3 w-full mt-3">
          {unduh && (
            <Link
              href={unduh}
              download
              target="_blank"
              className="bg-primary p-2.5 px-4 text-white text-center rounded-full shadow-md w-[140px] text-sm"
            >
              Unduh
            </Link>
          )}
          <Link
            href={href}
            className="bg-white p-2.5 px-4 border border-[#C7C7CD] text-center text-primary rounded-full shadow-md w-[140px] text-sm"
          >
            Lihat
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CardAnnoun;
